import React from 'react'
import { Calendar } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { FormGroup } from 'reactstrap'
import styled, { css } from 'styled-components'
import classnames from 'classnames'
import { english } from 'flatpickr/dist/l10n/default'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import { useIntl } from 'react-intl'
import flatpickr from 'flatpickr'

import { Show } from './commons'

const Picker = styled(Flatpickr).attrs({
  className: 'form-control',
})`
  background-color: #fff !important;
  border: 1px solid
    ${props =>
      props.invalid === 'true' ? props.theme.color.danger : '#d9d9d9'};
  color: #5f5f5f;
  text-align: left;
  padding: 5px !important;
  padding-left: ${props =>
    props.showIcon ? '40px !important' : '10px !important'};

  &:disabled {
    background-color: #f5f5f1 !important;
    opacity: 1;
  }
`

const FilteredFormGroup = ({
  showIcon: _showIcon,
  maxWidth: _maxWidth,
  children,
  ...props
}) => <FormGroup {...props}>{children}</FormGroup>

const Container = styled(FilteredFormGroup)`
  ${props => (props.width ? `width: ${props.width} !important;` : '')}
  max-width: ${props => `${props.maxWidth}px` || 'unset'};
  position: relative;

  &:focus-within {
    & > svg {
      color: #666;
    }
  }

  .form-control-position {
    bottom: 0;
    top: 0;
    margin-bottom: auto;
    margin-top: auto;
  }

  & > input {
    padding-left: ${props => (props['show-icon'] ? '36px' : '10px')};
  }

  & > svg {
    display: ${props => (props['show-icon'] ? 'block' : 'none')};
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 8px;
    color: #bbb;
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  ${props =>
    props.reviewModifier &&
    css`
      height: 1.8rem;
      width: 1.8rem;
    `}
`

function DateTimePicker(
  {
    maxWidth,
    width,
    showIcon = false,
    invalid,
    style,
    className,
    hasAppend = false,
    reviewModifier = false,
    placeholder = 'Select a date',
    ...props
  },
  ref
) {
  const intl = useIntl()
  flatpickr.localize(intl.locale === 'en' ? english : Portuguese)

  return (
    <Container
      style={style}
      show-icon={showIcon?.toString()}
      maxWidth={maxWidth}
      width={width}
      className="position-relative has-icon-left mb-0"
    >
      <Picker
        ref={ref}
        invalid={invalid?.toString()}
        className={`${className} ${classnames({
          'input-has-append-right': hasAppend,
        })}`}
        placeholder={intl.formatMessage({ id: placeholder })}
        {...props}
        showIcon={showIcon}
      />
      <Show condition={showIcon}>
        <IconContainer
          className="form-control-position"
          reviewModifier={reviewModifier}
        >
          <Calendar size={18} />
        </IconContainer>
      </Show>
    </Container>
  )
}

export default React.forwardRef(DateTimePicker)
